<template>
  <div class="searchItemTitle">{{ $t('Вид процедуры') }}</div>
  <div>
    <v-checkbox
      class="procedureStepCheckbox"
      :true-icon="'mdi-check mdi-18px'"
      :false-icon="'voidCheckbox'"
      v-model="isOpen"
      hide-details
      :label="$t('Открытая')"
      @change="() => change(false)"
    />

    <v-checkbox
      class="procedureStepCheckbox"
      :true-icon="'mdi-check mdi-18px'"
      :false-icon="'voidCheckbox'"
      v-model="isClosed"
      hide-details
      :label="$t('Закрытая')"
      @change="() => change(true)"
    />
  </div>
</template>

<script>
export default {
  name: 'ProcedureAccessibility',
  data() {
    return {
      isOpen: false,
      isClosed: false
    }
  },
  props: {
    searchParams: {
      type: Object,
      required: true,
    },
  },
  methods: {
    change(isClosed) {
      if (isClosed && this.isClosed) {
        this.isOpen = false;
      } else if (!isClosed && this.isOpen) {
        this.isClosed = false;
      }
      this.searchParams.isClosed = this.isClosed ? true : (this.isOpen ? false : null);
    }
  }
}
</script>
<style scoped>
:deep(.v-input--density-default) {
  --v-input-control-height: auto;
}
:deep(.v-selection-control--density-default) {
  --v-selection-control-size: 30px;
}
:deep(.procedureStepCheckbox .v-label) {
  color: rgb(var(--black-color));
  font-family: var(--primary-font-family-name);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  opacity: 1;
  padding-left: 13px;
}
:deep(.mdi-check.mdi-18px) {
  border-radius: 3px;
  border: 1px solid rgba(var(--black-color), 0.3);
}
:deep(.voidCheckbox) {
  border-radius: 3px;
  border: 1px solid rgba(var(--black-color), 0.3);
  background-color: rgb(var(--white-color));
}
</style>
